export const contactFormInitialValues = {
  subject: "Canco Cash Loyalty / Mobile App / Gift Card / Website",
  name: "",
  phone: "",
  email: "",
  message: "",
  attachment: "",
  cardnumber: "",
  related_to_store: "",
};

export const loginIntialValues = {
  email: "",
  password: "",
};

export const signupForm = {
  first_name: "",
  last_name: "",
  email: "",
  confirmEmail: "",
  phone: "",
  dob: null,
  address: null,
  password: "",
  confirmPassword: "",
  t_and_c_accepted: false,
  receive_promotions: true,
};

export const resetPasswordInitialValues = {
  password: "",
  confirmPassword: "",
};

export const addCardInitialValues = {
  cardnumber: "",
  ackroo_id: "",
};

export const accountDeletionInitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  reason: "",
  t_and_c_accepted: false,
  dateTime: "",
};

export const balanceTransferInitialValues = {
  from_card_number: "",
  to_card_number: "",
  deactivate_source_code: false,
  access_code: "",
};

export const dealerApplicationInitialValues = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  option_applies: [], // Array for checkboxes: "own_operate_gas_station", "own_property"
  gas_station_brand: "", // Max 5 words - for "I own and operate a gas station"
  property_details: "", // Max 200 words - for "I own a property"
  property_info: "", // Max 200 words - details about gas station or property
  lot_area_frontage: "", // Numeric only - sq ft
  on_site_businesses: [], // Checkboxes: "c_store", "carwash", "qsr", "others"
  qsr_brand: "", // Brand name for QSR
  others_specify: "", // Max 200 characters - for "Others" option
  fsa_in_place: "", // Yes/No - Fuel Supply Agreement
  fsa_expiry_date: "", // Date field - conditional on fsa_in_place = "yes"
  property_zoning: "", // Yes/No - zoned for gas station
};

export const retailAgentApplicationInitialValues = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  message: "",
  canadian_citizenship_or_pr: "",
  previous_experience: "",
  funding_overview: "",
  total_investment_amount: "",
  support_in_running_site: "",
  support_details: "",
  preferred_geographical_area: "",
  willing_to_participate_training: "",
  referral_available: "",
  referral_details: "",
};

export const realtorApplicationInitialValues = {
  first_name: "",
  last_name: "",
  company_name: "",
  email: "",
  phone: "",
  offering_lease_or_purchase: "",
  address: "",
  size_of_property: "",
  zoning: "",
  attachment: "",
};

export const vendorStepOneInitialValue = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  focused_product: "",
  distribution_model: "",
  company_name: "",
};

export const vendorStepTwoInitialValue = {
  edi_capabilities: "",
  minimum_order_levels: "",
  how_to_order: "",
  product_guarantee: "",
  distribution_reach: "",
  attachment: "",
};

export const fleetMemberStepOneInitialValues = {
  business_name: "",
  operating_as: "",
  business_type: "",
  years_of_company: "",
  years_of_operation: "",
  hst_exempt: "",
  expected_fuel_volume: "",
  no_of_cards_needed: "",
};

export const fleetMemberStepTwoInitialValues = {
  street: "",
  apartment: "",
  city: "",
  province: "",
  postcode: "",
  email: "",
  business_phone: "",
  cell: "",
};

export const fleetMemberStepThreeInitialValues = {
  contact_person: "",
  contact_person_phone: "",
  contact_person_email: "",
  contact_person_confirm_email: "",
  title: "",
};

export const fleetMemberStepFourInitialValues = {
  first_name: "",
  last_name: "",
  dob: "",
  street: "",
  apartment: "",
  city: "",
  province: "",
  postcode: "",
  sin: "",
};

export const fleetMemberStepFiveInitialValues = {
  financial_institution: "",
  branch: "",
  street: "",
  apartment: "",
  city: "",
  province: "",
  first_name: "",
  last_name: "",
  phone: "",
};

export const editUserProfileInitialValues = {
  first_name: "",
  last_name: "",
  dob: "",
  address: "",
  phone: "",
  email: "",
};

export const missingPointInitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  cardNumber: "",
  transactionNumber: "",
  uploadReceipt: "",
};

export const schoolSpiritInitialValues = {
  school_city: "",
  school_province: "",
  first_name: "",
  last_name: "",
  phone_number: "",
  email: "",
  card_number: "",
  school_name: "",
};

export const surveyFormInitialValues = {
  overall_experience: "0",
  enviornment: "0",
  merchandise: "0",
  service_experience: "0",
  loyalty_card: "0",
  comment: "",
};

export const wholesaleBusinessContactFormInitialValues = {
  name: "",
  phone: "",
  email: "",
  message: "",
};

export const xpressCardlockApplicationInitialValues = {
  // Section 1 - Business Information
  card_applying_for: "",
  customer_type: "",
  customer_type_other: "",
  hear_about_canco: "",
  hear_about_canco_other: "",
  financial_statement: "",
  legal_business_name: "",
  trade_name_dba: "",
  business_structure: "",
  years_in_business: "",
  // Section 2 - Contact Information
  business_number: "",
  gst_tax_exempt_number: "",
  business_mailing_address: "",
  contact_person_full_name: "",
  contact_person_title: "",
  contact_person_email: "",
  contact_person_phone: "",
  // Section 3 - Fleet Information
  fleet_size: "",
  total_anticipated_volume: "",
  number_of_cards: "",
  average_transaction: "",
  average_transactions_per_day: "",
  preferred_cardlock_location: "",
  price_notifications: false,
  price_notification_email: "",
  // Section 4 - Banking Reference
  banking_institution_name: "",
  transit_number: "",
  institution_number: "",
  account_number: "",
  void_cheque: "",
  // Acknowledgement
  acknowledgement: false,
};